import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation } from 'lucide-react';
import { OrnDivider } from './Ornaments';
import { VENUE_NAME, VENUE_ADDRESS, VENUE_MAP_EMBED, VENUE_MAP_LINK } from '../../lib/constants';
import { track } from '../../lib/analytics';

const VenueMap = () => (
  <section id="venue" data-testid="venue-section" className="scroll-mt-24 bg-ivory py-16 md:py-20">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <OrnDivider className="mb-5" />
        <h2 className="font-serif text-3xl tracking-tight text-ink md:text-4xl lg:text-5xl">
          Reach the Venue
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-base text-ink/65">
          {VENUE_NAME}, {VENUE_ADDRESS}
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.7 }}
        className="mt-10 overflow-hidden rounded-3xl border border-gold/30 bg-white shadow-[0_30px_70px_-45px_rgba(92,22,22,0.6)]"
      >
        <iframe
          title="Balakrishna Bayalu Ranga Mandira location"
          data-testid="venue-map-iframe"
          src={VENUE_MAP_EMBED}
          className="h-[360px] w-full border-0 md:h-[440px]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
        <div className="flex flex-col items-center justify-between gap-4 p-5 sm:flex-row md:p-6">
          <div className="flex items-center gap-3 text-center sm:text-left">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold-deep">
              <MapPin className="h-5 w-5" strokeWidth={1.7} />
            </span>
            <div>
              <p className="font-serif text-lg text-ink">{VENUE_NAME}</p>
              <p className="font-sans text-sm text-ink/60">{VENUE_ADDRESS}</p>
            </div>
          </div>
          <a
            href={VENUE_MAP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="venue-directions-btn"
            onClick={() => track('cta_directions', 'venue')}
            className="inline-flex items-center gap-2.5 rounded-full px-6 py-3 font-sans text-xs font-semibold uppercase tracking-[0.15em] text-ink transition-transform hover:-translate-y-0.5"
            style={{ background: 'linear-gradient(180deg,#F5D97A,#D4AF37 45%,#B38B22)' }}
          >
            <Navigation className="h-4 w-4" /> Get Directions
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default VenueMap;
